"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var getDecoders_1 = __importDefault(require("./queries/getDecoders"));
var record_1 = __importDefault(require("./queries/record"));
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
exports.fetchDecoders = function () {
    return api_1.createApiAction(constants_1.FETCH_DECODERS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getDecoders_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.requestRemoteRecord = function (recordSeries, startTime, channelId, skyDecoderBoxId) {
    return api_1.createApiAction(constants_1.RECORD, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: record_1.default,
            variables: {
                record: {
                    channelId: channelId,
                    startTime: startTime,
                    skyDecoderBoxId: skyDecoderBoxId,
                    recordSeries: recordSeries,
                },
            },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.resetRemoteRecord = function () { return toolkit_1.createAction(constants_1.RESET_REMOTE_RECORD)(); };
//# sourceMappingURL=actions.js.map